<template>
<div class="date-picker">
  <input type="date" :value="dateString" @change="onDateChange($event)" />
</div>
</template>
<script lang="ts">
import { defineComponent, inject, computed } from 'vue'
import type { Form } from '~/shared/form-types'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    type: {
      type: String,
      default: 'text',
    },
  },
  setup() {
    const { form, setValue, setTouched, getValue } = usePaymentForm()

    const field = inject<keyof Form>('field', 'dateOfBirth' as keyof Form)

    const dateString = computed(() => {
      const value = getValue(field)
      if (!value) return ''
      const d = value instanceof Date ? value : new Date(value as string)
      if (isNaN(d.getTime())) return ''
      return d.toISOString().split('T')[0]
    })

    function onDateChange(event: Event) {
      const val = (event.target as HTMLInputElement).value
      if (val) {
        setValue(field, new Date(val))
      }
    }

    return {
      form,
      setValue,
      setTouched,
      dateString,
      onDateChange,
    }
  },
})
</script>
<style scoped lang="scss">
.date-picker {
  margin-top: 24px;

  input[type='date'] {
    box-sizing: border-box;
    height: 44px;
    width: 100%;
    display: block;
    border: 1px solid #ddd;
    padding: 0 10px;
    border-radius: 4px;
    background: #f7f9fb;
    transition: all 0.3s ease-in-out;
    font-size: 14px;
    color: #222;

    &:hover {
      border-color: $color-blue;
    }

    &:focus {
      border-color: $color-blue;
      color: #222;
      background: white;
      box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }

    @media only screen and (min-width: 720px) {
      height: 42px;
    }
  }
}
</style>